export const propsTypes = {
  name: "variants",
  email: "text",
  phone: "text",
  address: "text",
  text: "text",
  number: "text",
  textarea: "text",
  select: "select",
  multiselect: "multiselect",
  multiemail: "textList",
  radioInput: "objectiveWithInput",
  checkbox: "multiselect",
  radio: "select",
  boolean: "boolean",
} as const;
